import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'

import Icon from '../utility/Icon'
import BurgerButton from './BurgerButton'
import { currentSite } from '../../mixins/siteDetection'

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      settingsVisible: false
    }

    this.onSearchSubmit = this.onSearchSubmit.bind(this)
  }

  onSearchSubmit(e) {
    e.preventDefault()
    const input = e.currentTarget.closest('form').querySelector('input')

    const query = input.value
    if (!query || query === '') {
      return false
    }

    this.props.history.push('/search?query=' + query)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      document.querySelector('.search-bar input').value = ''
    }
  }

  render() {
    const site = currentSite()

    return (
      <header className="page-header">
        <nav className="container">
          <ul className="desktop d-none d-lg-block">
            <li>
              <Link className="logo" type="nav" to="/" />
            </li>
            <li>
              <Link type="nav" to="/parodies">
                Parodies
              </Link>
            </li>
            <li>
              <Link type="nav" to="/tags">
                Tags
              </Link>
            </li>
            <li>
              <Link type="nav" to="/artists">
                Artists
              </Link>
            </li>
            <li>
              <Link type="nav" to="/characters">
                Characters
              </Link>
            </li>
            <li>
              <button>Languages</button>
              <ul>
                <li>
                  <Link to="/language/english">
                    <Icon type="flag" icon="gb" /> English
                  </Link>
                </li>
                <li>
                  <Link to="/language/japanese">
                    <Icon type="flag" icon="jp" /> Japanese
                  </Link>
                </li>
                <li>
                  <Link to="/language/chinese">
                    <Icon type="flag" icon="cn" /> Chinese
                  </Link>
                </li>
                <li>
                  <Link to="/language/german">
                    <Icon type="flag" icon="de" /> German
                  </Link>
                </li>
                <li>
                  <Link to="/language/french">
                    <Icon type="flag" icon="fr" /> French
                  </Link>
                </li>
                <li>
                  <Link to="/language/korean">
                    <Icon type="flag" icon="kr" /> Korean
                  </Link>
                </li>
                <li>
                  <Link to="/language/spanish">
                    <Icon type="flag" icon="es" /> Spanish
                  </Link>
                </li>
                <li>
                  <Link to="/language/russian">
                    <Icon type="flag" icon="ru" /> Russian
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <a href="https://s.zlinkd.com/d.php?z=5182276" target="_blank">
                Games
              </a>
            </li>
            <li className="search-bar">
              <form>
                <input
                  type="text"
                  name="q"
                  autoComplete="off"
                  defaultValue=""
                />
                <button aria-label="Search" onClick={this.onSearchSubmit}>
                  <Icon icon="search" />
                </button>
              </form>
            </li>
          </ul>

          <div className="mobile d-block d-lg-none">
            <div className="row no-gutters align-items-center">
              <div className="col-4">
                <BurgerButton />
              </div>
              <div className="col-8">
                <Link to="/">
                  {site.siteKey === 'doujin' && <div className="logo" />}{' '}
                  <div className="title">{site.siteTitle}</div>
                </Link>
              </div>
              <div className="col-12">
                <form className="row align-items-center">
                  <div className="col-11">
                    <input
                      type="text"
                      name="q"
                      autoComplete="off"
                      defaultValue=""
                    />
                  </div>
                  <div className="col-1">
                    <button aria-label="Search" onClick={this.onSearchSubmit}>
                      <Icon icon="search" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </nav>
      </header>
    )
  }
}

export default withRouter(Header)
